import React from "react"

function IconCar({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="car"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-car"
      {...props}
    >
      <path
        d="M19.427 2.945c.245 0 .467.137.579.349l.04.095 2.139 6.276a.659.659 0 0 1 .027.108c.057.133.096.277.111.427l.008.153v10.156a.764.764 0 0 1-.764.764H19.2a.764.764 0 0 1-.764-.764v-2.903H5.442v2.903a.764.764 0 0 1-.763.764H2.313a.764.764 0 0 1-.764-.764l.002-10.236a.593.593 0 0 1 .007-.149l.038-.14c.018-.073.043-.143.072-.21l2.185-6.386a.655.655 0 0 1 .516-.434l.104-.009h14.954zm1.431 7.244H3.022c-.06 0-.111.031-.14.078l-.022.066-.002.02v5.944h18.164v-5.944a.163.163 0 0 0-.067-.132l-.045-.024-.052-.008zm-2.89 1.2a1.855 1.855 0 1 1 0 3.71 1.855 1.855 0 0 1 0-3.71zm-12.055 0a1.855 1.855 0 1 1 0 3.71 1.855 1.855 0 0 1 0-3.71zm13.046-7.134H4.939L3.359 8.879h17.176L18.96 4.255z"
        fill={color}
        fillRule="evenodd"
        style={{ height: height || fontSize }}
        originalclass="__primary"
      />
    </svg>
  )
}

export default IconCar
